export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.6-0933.10",
  commitId: "fd759b7224bae5897be9320296d80a1c68826628",
  commitTime: "2026-08-06T09:33:10.000Z",
});
